import { useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

// Global keyboard shortcuts hook
export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleKeyDown = useCallback((e) => {
    // Skip if user is typing in an input, textarea, or contenteditable
    const activeElement = document.activeElement;
    const tagName = activeElement?.tagName?.toLowerCase();
    const isEditing = 
      tagName === 'input' || 
      tagName === 'textarea' || 
      activeElement?.isContentEditable ||
      activeElement?.closest('[role="dialog"]') ||
      activeElement?.closest('[role="combobox"]');
    
    if (isEditing) return;

    // Ctrl+K / Cmd+K - Search (already handled by GlobalSearch component)
    // This is just for documentation purposes

    // n - Create new Work Request (all roles)
    if (e.key === 'n' && !e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey) {
      e.preventDefault();
      navigate('/work-requests?action=create');
    }

    // Shift+N - Create new Work Order (admin/supervisor only)
    if (e.key === 'N' && e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey) {
      if (user?.role === 'admin' || user?.role === 'supervisor') {
        e.preventDefault();
        navigate('/work-orders?action=create');
      }
    }

  }, [navigate, user]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return null;
}

export default useKeyboardShortcuts;
